export default "__VITE_ASSET__CpVdfnVl__"